<template>
    <div class="checkbox-wrapper">
        <span class="checkbox" :class="{ on: checked }" @click="clickHandler"></span>
    </div>
</template>

<script>
/**
 * emit colClick, emit valueChange
 */
/* eslint-disable */
export default {
    name: "Checkbox",
    props: ["data"],
    data() {
        return {
            checked: !!this.data
        };
    },
    watch: {
        data(newVal) {
            this.checked = newVal;
        }
    },
    methods: {
        clickHandler(event) {
            this.checked = !this.checked;

            let newEvent = {
                event: event,
                checked: this.checked,
                type: "Checkbox"
            }

            this.$emit("colClick", newEvent);

            this.$emit("valueChange", newEvent);
        }
    }
};
</script>

<style lang="scss" scoped>
.checkbox-wrapper {
    text-align: center;

    .checkbox {
        left: 24px;
        display: inline-block;
        border-radius: 3px;
        width: 16px;
        height: 16px;
        vertical-align: -3px;
        background: url($zhijiStaticImagePath + "class-spr.png") no-repeat -168px 0;
        &:hover{
            background-position: -145px 0;
        }
        &.on {
            background-position: -145px -24px;
        }
    }
}
</style>
